import React from 'react';
import CheckIcon from '@material-ui/icons/Check';

const PassedIcon = (): JSX.Element => {
  return (
    <div style={{ color: '#29cc97' }}>
      <CheckIcon />
    </div>
  );
};

export default PassedIcon;
